import { render, staticRenderFns } from "./LogImportDetail.vue?vue&type=template&id=c55c2f7a&"
import script from "./LogImportDetail.vue?vue&type=script&lang=js&"
export * from "./LogImportDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogImportDetail.vue?vue&type=style&index=0&id=c55c2f7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports